import React, { useState } from "react";
import {
  TextField,
  FormControl,
  Modal,
  Box,
  InputAdornment,
  IconButton,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import host from "../../host";
import MessageSnackbar from "../../_layout/elements/snackbar";

function ResetPassword() {
  const [open1, setOpen1] = React.useState(false);
  const [oldPassword, setOldPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [showOldPassword, setShowOldPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const active = () => setOpen1(true);
  const handleClose1 = () => {
    setOpen1(false);
    setError("");
    setSuccessMessage("");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "old_password") setOldPassword(value);
    else if (name === "new_password") setNewPassword(value);
    else if (name === "confirm_password") setConfirmPassword(value);
  };

  const [snackbar, setSnackbar] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const onClose = () => {
    setSnackbar(false);
  };

  const handleSubmit = async () => {
    handleClose1();


    try {
      if (!oldPassword) {
        setSeverity("error");
        setMessage("Old password is required");
        setSnackbar(true);
        return;
      }
      
      if (!newPassword) {
        setSeverity("error");
        setMessage("New password is required");
        setSnackbar(true);
        return;
      }
      
      if (!confirmPassword) {
        setSeverity("error");
        setMessage("Confirm password is required");
        setSnackbar(true);
        return;
      }
      const response = await fetch(host.chaturl + "/user/reset_password", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: JSON.stringify({
          old_password: oldPassword,
          new_password: newPassword,
        }),
      });

      const data = await response.json();
      if (response.ok) {
        setSeverity("success");
        setMessage("Password reset successfully");
        setSnackbar(true);
        setOldPassword("");
        setNewPassword("");
        setConfirmPassword("");
      } else {
        if (response.status === 400) {
        setSeverity("error");
        setMessage(data.detail);
        setSnackbar(true);
        } else {
        setSeverity("error");
        setMessage("An error occurred. Please try again later.");
        setSnackbar(true);
        }
      }
    } catch (error) {
      setSeverity("error");
      setMessage("An error occurred. Please try again later.");
      setSnackbar(true);
    } finally {
      setOpen1(false);
    }
  };

  return (
    <>
    <MessageSnackbar open={snackbar} autoHideDuration={3000} onClose={onClose} severity={severity} message={message} />
      <div className="card">
        <div className="card-body">
          <div className="card-summary-head">
            <div className="summary-title-tow">
              <h5 className="d-flex align-items-center "> Reset Password</h5>
            </div>
          </div>
          <div className="company-profile-wrapper">
            <div className="candidate-profile-detail">
              <div className="row">
                <div className="col-lg-8">
                  <div className="row">
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                      <div className="form-group">
                        <label>Old Password </label>
                        <FormControl fullWidth>
                          <TextField
                            name="old_password"
                            size="small"
                            type={showOldPassword ? "text" : "password"}
                            placeholder="Enter your old password"
                            value={oldPassword}
                            onChange={handleChange}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={() =>
                                      setShowOldPassword(!showOldPassword)
                                    }
                                    edge="end"
                                  >
                                    {showOldPassword ? (
                                      <Visibility />
                                    ) : (
                                      <VisibilityOff />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </FormControl>
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                      <div className="form-group">
                        <label>New Password</label>
                        <FormControl fullWidth>
                          <TextField
                            name="new_password"
                            size="small"
                            type={showNewPassword ? "text" : "password"}
                            placeholder="Enter your new password"
                            value={newPassword}
                            onChange={handleChange}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={() =>
                                      setShowNewPassword(!showNewPassword)
                                    }
                                    edge="end"
                                  >
                                    {showNewPassword ? (
                                      <Visibility />
                                    ) : (
                                      <VisibilityOff />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                        </FormControl>
                      </div>
                    </div>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                      <div className="form-group">
                        <label> Confirm Password </label>
                        <FormControl fullWidth>
                          <TextField
                            name="confirm_password"
                            size="small"
                            type={showConfirmPassword ? "text" : "password"}
                            placeholder="Confirm your new password "
                            value={confirmPassword}
                            onChange={handleChange}
                            InputProps={{
                              endAdornment: (
                                <InputAdornment position="end">
                                  <IconButton
                                    onClick={() =>
                                      setShowConfirmPassword(
                                        !showConfirmPassword
                                      )
                                    }
                                    edge="end"
                                  >
                                    {showConfirmPassword ? (
                                      <Visibility />
                                    ) : (
                                      <VisibilityOff />
                                    )}
                                  </IconButton>
                                </InputAdornment>
                              ),
                            }}
                          />
                          {newPassword !== confirmPassword && (
                            <span
                              className="error text-danger mt-2"
                              id="confirm_password_error"
                            >
                              {" "}
                              Passwords do not match
                            </span>
                          )}
                          {newPassword === confirmPassword &&
                            newPassword !== "" && (
                              <span
                                className="error text-success mt-2"
                                id="confirm_password_error"
                              >
                                {" "}
                                Passwords Match
                              </span>
                            )}
                        </FormControl>
                        {error && (
                          <span className="error text-danger d-block mt-2">
                            {error}
                          </span>
                        )}
                        {successMessage && (
                          <span className="error text-success d-block mt-2">
                            {successMessage}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="submit-section mt-3 mb-3 text-center">
                      <button
                        type="button"
                        className="btn btn-primary submit-btn"
                        onClick={() => setOpen1(true)}
                      >
                        Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Modal
        open={open1}
        onClose={handleClose1}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="commonpopup modal-common popup-w35">
          <div className="modal-body">
          <div className="popup_scroller">
            <div className="model-content text-center">
              <h3>Are you sure you want to save?</h3>
            </div>
            <div className="modal-btn">
              <button
                className="btn btn-success btn-block"
                onClick={handleSubmit}
              >
                Confirm
              </button>
              <button
                className="btn btn-danger btn-block"
                onClick={handleClose1}
              >
                Cancel
              </button>
            </div>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default ResetPassword;
